function toggleHeaderTransparency() {
  const body = document.body;
  const header = document.querySelector('header[data-section-type="header"]');

  if (window.innerWidth >= 990) {
    body.classList.remove('header-transparent');
    if (header) {
      header.classList.remove('header--transparent'); // Important: aussi retirer du header
    }
  } else {
    if (document.querySelector('[data-transparent-header="true"]')) {
      body.classList.add('header-transparent');
      if (header) {
        header.classList.add('header--transparent'); // Important: remettre sur mobile
      }
    }
  }
}

// Quand la page est chargée
document.addEventListener('DOMContentLoaded', toggleHeaderTransparency);

// Quand la fenêtre est redimensionnée
window.addEventListener('resize', toggleHeaderTransparency);